import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/app/router";
import { Toaster } from "@/components/ui/toast";
import { ConfirmHost } from "@/components/ui/confirm";
import { LoginIntro } from "@/components/brand/LoginIntro";
import { startThemeSync } from "@/features/theme/theme";
import { installNativeMenuGuard } from "@/lib/nativeMenu";
import { startVersionWatch } from "@/lib/version";
import "@fontsource-variable/geist";
import "./index.css";
import "@/i18n";

startThemeSync();
installNativeMenuGuard();
startVersionWatch();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
      <ConfirmHost />
      <LoginIntro />
    </QueryClientProvider>
  </StrictMode>,
);
